export default __webpack_public_path__ + "static/media/res.da5d4cd8.svg";